// extracted by mini-css-extract-plugin
export default {"lds-spinner":"LoadingStyle_lds-spinner__PJqLi"};